import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/Login';
import { CamerasPage } from './pages/Cameras';
import { CameraViewPage } from './pages/CameraView';
import { GridViewPage } from './pages/GridView';
import { useAuthStore } from './store/authStore';
import './styles/globals.css';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/cameras"
          element={
            <ProtectedRoute>
              <CamerasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cameras/:documentId"
          element={
            <ProtectedRoute>
              <CameraViewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/grid"
          element={
            <ProtectedRoute>
              <GridViewPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/cameras" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
